function getArticleLink(slug: string): string {
  return `/${slug}/`;
}

export { getArticleLink };
